import React from "react";
import marked from 'marked';

import CDNImage from '../common/cdn-image';
import FurtherReadingByline from "./further-reading-byline";
import FurtherReadingDropdown from "./further-reading-dropdown";

class FurtherReadingListBookItem extends React.Component {
  render() {
    return (
      <li className="further-reading__list-item">
        <div className="further-reading__details">
          <div
            className="further-reading__title"
            dangerouslySetInnerHTML={{ __html: marked(this.props.item.data.Title).replace('<p>','').replace('</p>','')}}
          />
          <FurtherReadingByline
            author={this.props.item.data.Author}
            editor={this.props.item.data.Editor}
            translator={this.props.item.data.Translator}
          />

          {(this.props.item.data.Description) ? (
            <p
              className="further-reading__description"
              dangerouslySetInnerHTML={{ __html: marked(this.props.item.data.Description).replace('<p>','').replace('</p>','')}}
            >
            </p>
          ) : null}
          {(this.props.item.data.ASIN || this.props.item.data.Publisher_URL) ? (
            <div className="further-reading__buy-button">
              <FurtherReadingDropdown
                data={this.props.item.data}
              />
            </div>
          ) : null}
        </div>

        {(this.props.item.data.Cover_Image_Path) ? (
          <div className="further-reading__cover">
            <CDNImage
              imagePath={this.props.item.data.Cover_Image_Path}
              alt={`${this.props.item.data.Tite} cover`}
            />
          </div>
        ) : null}
      </li>
    );
  }
}

export default FurtherReadingListBookItem;
